import SearchModalPodcastResults from './SearchModalPodcastResults';

export default SearchModalPodcastResults;
